import { render } from "./DeletionModal.vue?vue&type=template&id=6444da52"
import script from "./DeletionModal.vue?vue&type=script&lang=js"
export * from "./DeletionModal.vue?vue&type=script&lang=js"

import "./DeletionModal.vue?vue&type=style&index=0&id=6444da52&lang=css"

import exportComponent from "/Users/ewelling/dev/LUMI-O-Auth-GUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__